// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
Vue.config.productionTip = false;       // turn on/off annoying production tip
Vue.config.silent = true;               // turn on/off warnings in console

import App from './App';
import Multiselect from 'vue-multiselect';
import NProgress from 'vue-nprogress';
import Vue from 'vue';
import VueBlu from 'vue-blu';
import VueConfig from 'vue-config';
import VueI18n from 'vue-i18n';
import VueLazyload from 'vue-lazyload';
import VueLightbox from 'vue-lightbox';
import auth from './auth';
import axios from 'axios';
import customButton from './components/utils/customButton'
import formInput from './components/utils/incl-form';
import impersonateButton from './components/utils/impersonateButton'
import inputCounter from './components/utils/inputCounter'
import label from './components/utils/label'
import lang from './components/utils/Language'
import loadingIndicatorBounce from 'vue-spinner/src/BounceLoader.vue'
import loadingIndicatorMoon from 'vue-spinner/src/MoonLoader.vue'
import loadingIndicatorPulse from 'vue-spinner/src/PulseLoader.vue'
import mixins from './components/utils/mixins.js';
import modalLabel from './components/utils/Modal'
import pageHeading from './components/PageHeading'
import router from './router';
import { siteConfig } from './config'
import store from './vuex/store';

window.$ = window.jQuery = require('jquery');

/**
 * =============================================================================
 * PLUGINS
 * =============================================================================
 */

// i18n - https://github.com/kazupon/vue-i18n
// -----------------------------------------------------------------------------

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: store.state.currentLang,
    fallbackLocale: 'de',
    silentTranslationWarn: true,
    messages: store.state.labels
});


// axios - https://github.com/imcvampire/vue-axios
// -----------------------------------------------------------------------------

Vue.prototype.axios = axios;
// axios.defaults.baseURL = process.env.SERVER_URL


// vueConfig - https://github.com/airyland/vue-config
// -----------------------------------------------------------------------------

Vue.use(VueConfig, siteConfig);


// NProgress - https://github.com/vue-bulma/nprogress
// -----------------------------------------------------------------------------

Vue.use(NProgress);
const nprogress = new NProgress({ showSpinner: false, ease: 'ease' });


// VueBlu - https://github.com/chenz24/vue-blu
// -----------------------------------------------------------------------------

Vue.use(VueBlu);


// VueLazyLoad - https://github.com/hilongjw/vue-lazyload
// -----------------------------------------------------------------------------

Vue.use(VueLazyload, {
    src: '',
    error: require('../src/assets/img/image-not-found.jpg'),
    loading: require('../src/assets/img/ajax-spinner-ring.gif'),
})


/**
 * =============================================================================
 * GLOBAL COMPONENTS
 * =============================================================================
 */




 // https://vue-multiselect.js.org/
// import 'vue-multiselect/dist/vue-multiselect.min.css'

    // https://www.npmjs.com/package/vue-lightbox










Vue.component('loadingIndicator', loadingIndicatorMoon);
Vue.component('loadingIndicatorSmall', loadingIndicatorBounce);
Vue.component('loadingIndicatorBounce', loadingIndicatorBounce);
Vue.component('loadingIndicatorPulse', loadingIndicatorPulse);
Vue.component('loadingIndicatorTable', loadingIndicatorPulse);

Vue.component("Lightbox", VueLightbox);
Vue.component('modalLabel', modalLabel);
Vue.component('customButton', customButton);
Vue.component('formInput', formInput);
Vue.component('inputCounter', inputCounter);
Vue.component('lang', lang)
Vue.component('pageHeading', pageHeading)
Vue.component('impersonateButton', impersonateButton)
Vue.component('labelName', label)
Vue.component('multiselect', Multiselect);


// include flowtype jQuery Plugin
require('../src/assets/js/flowtype.js');


// mixins
// -----------------------------------------------------------------------------

Vue.mixin(mixins);


// axios interceptor -> fetch 401 status and redirect to login page
// -----------------------------------------------------------------------------
axios.interceptors.response.use(function (response) {

  return response;

}, function (error) {
  
  if(typeof error.response != 'undefined') {

    console.log("## axios error response: ", error.response.data);
    // if there was a 401 status response, securely logout the user and redirect him to the login page
    if (error.response.status === 401) {
      auth.logout(true);
    }

    // missing authorization
    else if(error.response.status === 403) {
      error.response.message = 'Fehlende Berechtigung;'
      return Promise.reject(error)
    }

    // A 500 during an active session most likely means the auth token has
    // expired / become invalid. Trigger logout so the user can re-authenticate.
    // The isLoggingOut guard in auth.logout() prevents an infinite loop in case
    // the logout API endpoint itself also returns a 500.
    else if(error.response.status === 500 && store.getters.isLoggedIn) {
      console.warn("## 500 received while logged in – triggering logout");
      // auth.logout(true);
      return Promise.reject(error.response.data);
    }
    
    else {
      return Promise.reject(error.response.data);
    }

  // other errors -> default promise return 
  } else {
    return Promise.reject(error.response ? error.response.data : error);
  }

});


// Before Each Route
// -----------------------------------------------------------------------------
router.beforeEach(async (to, from, next) => {

    // set the document title
    document.title = to.meta.title ? to.meta.title + ' | ' + siteConfig.siteTitle : siteConfig.siteTitle;

    // embedded calendar view
    if(to.path.substr(0,18) == '/embedded-calendar') {
        next();
    }

    // marketing cockpit
    else if(to.name == 'marketingCockpit') {
        auth.loginMarketingCockpit(to);
    }

    // route logout
    else if(to.path == '/logout') {

        await auth.logout();
        
    }

    // route login
    else if(to.name == 'login') {

      console.log("... redirecting to login")
      next();

    }  

    else if(!store.getters.isLoggedIn && localStorage.getItem('token') != null) {
      console.log("re-authenticating ...");
      await auth.reAuthenticate(to.path);
      next(to.path);
    }

    // user is not loggedIn and no token in storage ...
    else if(!store.getters.isLoggedIn && localStorage.getItem('token') == null) {

      if(to.path != '/login') {

        if(to.path == '/recover') {
          next();
        } else {
          next({
              name: 'login',
              query: (to.path == '/' || to.path == '/login' || to.path == '/logout')
                  ? ''
                  : { redirect: to.fullPath }
          });
        }

      } else {
        next({ name: 'login'});
      }

    }

    // user is logged in
    else {

      // in case of print view, we add a "print-view" class to the body element
      if(to.meta.isPrintView == true) {
          document.body.classList.add("print-view");
          next();
      }

      if(to.path == '/recover') {
          next('/');
      }

      // define landing pages for user-roles
      if(store.getters.getUser != null) {

        if (store.getters.getUser && store.getters.getUser.defaultRoute && store.getters.getUser.defaultRoute != '') {

          if(to.path == '/' && to.path != '/account' && store.getters.getUser.defaultRoute != to.path.substr(0, store.getters.getUser.defaultRoute.length)) {

            switch(store.getters.getUser.defaultRoute) {
              case '/katalog':
                next({ name: 'catalog'});
                break;
              case '/produkte':
                next({ name: 'produkte'});
                break;
              case '/kalender':
                next({ name: 'calendar'});
                break;
              case '/apotheken':
                next({ name: 'apotheken'});
                break;
              case '/geraete-katalog':
                next({ name: 'equipmentCatalog'});
                break;
              case '':
              case 'null':
                next({ name: 'apotheken'});
                break;
              default:
                next({ name: store.getters.getUser.defaultRoute});
            }

          } else {
            next();
          }

        } else {
          next();
        }

      } else {
        next('/');
      }

    }

});



// start the app
const app = new Vue({

    el: '#app',

    mounted() {
        this.$el.addEventListener('click', this.onClick)
    },
    beforeDestroy() {
        this.$el.removeEventListener('click', this.onClick)
    },

    methods: {

        onClick(ev) {

            if(!$('.flatpickr-input').get(0) || ev.target.className == 'form-control input active') {
                return false;
            } else {
                let matches = document.querySelectorAll('.flatpickr-input');
                if(matches.length > 0) {
                    matches.forEach(match => {
                        if (match._flatpickr && typeof match._flatpickr.close === 'function') {
                            match._flatpickr.close();
                        }
                    })
                }
            }

        },

    },

    router,
    store,
    nprogress,
    i18n,
    render: h => h(App)
})
// }).$mount('#app');



export default app;
